export default "__VITE_ASSET__6ydjNTkL__"